<template>
    <div class="box">
        <a href="https://web.whatsapp.com/send?phone=51948489822&text=Hola necesito ayuda/información sobre el sistema Facturación Online" target=":blank" class="enlace">
            <img src="images/whatsapp-logo.svg" class="logo">
            <span class="tooltip">¿Hola, cómo podemos ayudarte?</span>
        </a>
    </div>
</template>
<script>

export default{
    name:"botonWhatsApp"
}
</script>
<style scoped>
.enlace{
 background-color: #18a72e;
 color: #fff;
 padding: 10px 15px;
 border-radius: 50px;
 text-decoration: none;
}
.logo{
width: 20px;
height: 20px;
}

/* Estilo del texto que aparecerá al pasar el mouse */
.tooltip {
    visibility: hidden;
    opacity: 0;
    background-color: #18a72e;
    color: #fff;
    padding: 10px;
    border-radius: 50px;
    position: absolute;
    top: 50%;
    right: 50px; /* Posiciona el texto a la derecha del botón */
    transform: translateY(-50%);
    white-space: nowrap;
    z-index: 1;
    transition: opacity 0.3s ease, visibility 0.3s ease;
}

/* Mostrar el texto cuando se hace hover */
.enlace:hover .tooltip {
    visibility: visible;
    opacity: 1;
}
</style>

